import React, { useState } from 'react';
import { Button } from 'components/ui/index';
import Popover, { PopoverHeader, PopoverBody } from 'components/ui/popover';
import { useI18n } from 'hooks/use_i18n';
import { v4 as uuidv4 } from 'uuid';

const Confirm = ({ size, outline, cancel, confirm }) => {
  const { t } = useI18n();
  return (
    <>
      <PopoverHeader>{t('components.ui.confirm_button.confirm_title')}</PopoverHeader>
      <PopoverBody>
        <div className="d-flex">
          <Button color="danger" size={size} outline={outline} onClick={cancel} className="mr-1" data-cy="cancel_action_button">
            {t('components.ui.confirm_button.cancel')}
          </Button>
          <Button color="success" size={size} outline={outline} onClick={confirm} data-cy="confirm_action_button">
            {t('components.ui.confirm_button.confirm')}
          </Button>
        </div>
      </PopoverBody>
    </>
  );
};

const ConfirmButton = ({ onClick, size, outline, disabled, ...restProps }) => {
  const [buttonId] = useState(uuidv4());
  const [shouldConfirm, setShouldConfirm] = useState(false);
  const id = `confirm_button_${buttonId}`;
  return (
    <>
      <Button
        {...restProps}
        size={size}
        outline={outline}
        id={id}
        disabled={disabled}
        onClick={() => {
          setShouldConfirm(true);
        }}
      />
      <Popover
        target={id}
        trigger="click"
        placement="top"
        isOpen={shouldConfirm}
        onToggle={(next) => setShouldConfirm(next)}
        data-cy="confirm_action_popover"
      >
        <Confirm
          confirm={() => {
            onClick();
            setShouldConfirm(false);
          }}
          cancel={() => setShouldConfirm(false)}
          outline={outline}
          size={size}
        />
      </Popover>
    </>
  );
};
export default ConfirmButton;
